import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { useWindowSize } from '../../../../utils/hooks';
import classes from './TimesheetHeader.module.scss';
import { responsiveSizeTimesheet, timesheetsStatuses } from '../../../../utils/constants';
import InfoSign from '../../../common/InfoSign/InfoSign';
import KeyValueLabel from '../../../common/labels/KeyValueLabel/KeyValueLabel';
import StatusLabel from '../../../common/labels/StatusLabel/StatusLabel';
import InfoIcon from '../../../common/Icons/InfoIcon';

export default function TimesheetsHeader({ timesheet, isApprover }) {
  const { t } = useTranslation();
  const size = useWindowSize();

  return (
    <div className={classes.container}>
      {size.width > responsiveSizeTimesheet ? (
        <p className={classes.monthLabel}>&nbsp;</p>
      ) : (
        <div className={classes.mobileClientPlacement}>
          <p className={classes.clientName}>
            {isApprover ? `${timesheet?.User?.FirstName} ${timesheet?.User?.LastName}` : timesheet?.ClientName},&nbsp;
          </p>
          <p className={classes.placement}>{timesheet?.Placement}</p>
        </div>
      )}
      <div className={isApprover ? classes.rightPartApproverContainer : classes.rightPartContainer}>
        {size.width > responsiveSizeTimesheet &&
          ![timesheetsStatuses(t).approved.apiStatus, timesheetsStatuses(t).processed.apiStatus].includes(
            timesheet.Status.Status
          ) &&
          (!isApprover || timesheetsStatuses(t).rejected.apiStatus) !== timesheet.Status.Status && (
            <InfoSign
              text={isApprover && `${timesheet?.User?.FirstName} ${timesheet?.User?.LastName}`}
              icon={<InfoIcon />}
            >
              <Box
                sx={{
                  width: 'max-content',
                  padding: '32px 24px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  gap: '14px',
                  backgroundColor: '#F6F7F9',
                  boxShadow: size.width > responsiveSizeTimesheet ? '0 4px 4px rgba(0, 0, 0, 0.25)' : 'none',
                  borderRadius: '20px'
                }}
              >
                <KeyValueLabel
                  label={
                    isApprover ? t('dashboard.timesheet.header.contractor') : t('dashboard.timesheet.header.client')
                  }
                  value={
                    isApprover ? `${timesheet?.User?.FirstName} ${timesheet?.User?.LastName}` : timesheet?.ClientName
                  }
                />
                <KeyValueLabel label={t('dashboard.timesheet.header.jobtitle')} value={timesheet?.Placement} />
                <KeyValueLabel label={t('dashboard.timesheet.header.order')} value={timesheet?.PO || '-'} />
                <KeyValueLabel label={t('dashboard.timesheet.header.recordn')} value={timesheet?.RecordNo} />
              </Box>
            </InfoSign>
          )}
        {((![timesheetsStatuses(t).approved.apiStatus, timesheetsStatuses(t).processed.apiStatus].includes(
          timesheet.Status.Status
        ) &&
          (!isApprover || timesheetsStatuses(t).rejected.apiStatus) !== timesheet.Status.Status) ||
          size.width <= responsiveSizeTimesheet) && (
          <KeyValueLabel
            label=""
            value={
              <StatusLabel
                type={timesheet?.Status?.Status.toLowerCase()}
                text={timesheet?.Status?.Status}
                isApprover={isApprover}
              />
            }
          />
        )}
      </div>
    </div>
  );
}
